// extracted by mini-css-extract-plugin
export default {"title":"Grouped_title__1UlXx","header":"Grouped_header__6FyPa","count":"Grouped_count__74dhs","groupedRowContainer":"Grouped_groupedRowContainer__56yQA"};